<template>
  <div class="animated fadeIn">
    <div id="Dashboard">Dashboard</div>
    <!--<b-card-group columns class="card-columns">-->
    <b-card header="Bar Chart">
      <b-row>
        <b-col sm="4">
          <h4 id="traffic" class="card-title mb-0">Web Click Report</h4>
          <!--<div class="small text-muted">November 2017</div>-->
        </b-col>
        <b-col sm="8" class="d-md-block">
          <b-form inline>
            <label class="mb-2 mr-sm-2 mb-sm-0" for="action-select">Select Action :</label>
            <b-form-select id="action-select" class="mb-2 mr-sm-2 mb-sm-0" :options="actions" v-model="form.action">
            </b-form-select>
            <label class="mb-2 mr-sm-2 mb-sm-0"> Select Date : &nbsp;</label>
            <date-range-picker
                    :startDate="startDate"
                    :endDate="endDate"
                    @update="updateValues"
                    :locale-data="locale"
                    class="mb-2 mr-sm-2 mb-sm-0"
            >
              <div slot="input" slot-scope="picker">
                {{ picker.startDate | date }} - {{ picker.endDate | date }}
              </div>
            </date-range-picker>
            <b-button variant="success" :startDate="startDate" :endDate="endDate" @click="updateValues">Apply</b-button>
            <label v-if="chart_loading">&nbsp;<i class="fa fa-spinner fa-pulse"></i></label>
          </b-form>
        </b-col>
      </b-row>
      <div class="chart-wrapper">
        <bar-report-click chartId="chart-bar-01" :bar_data="chart_data"/>
        <!--<bar-report-click chartId="chart-bar-01" style="height:300px;margin-top:40px;" height="300" ></bar-report-click>-->
      </div>
    </b-card>
    <!--</b-card-group>-->
  </div>
</template>

<script>
  import DateRangePicker from 'vue2-daterange-picker'
  import BarReportClick from './charts/BarReportClick'
  import moment from 'moment-timezone'
  import axios from 'axios'

  //start - for toastr notifications
  import Vue from 'vue'
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'

  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  };

  miniToastr.init({types: toastTypes});

  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }

  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  };
  //  VueNotifications.setPluginOptions(options)

  Vue.use(VueNotifications, options);
  //end - for toastr notifications

export default {
  name: 'Dashboard',
  components: {
    DateRangePicker: DateRangePicker,
    BarReportClick: BarReportClick
  },
  filters: {
    date (value) {
      let options = {year: 'numeric', month: 'long', day: 'numeric'};
      return Intl.DateTimeFormat('en-US', options).format(value)
    }
  },
  data: function() {
    return {
      // selected: 'Month',
      opens: 'left',
      startDate: '2018-12-01', //TODO: initial startDate - Last Month ?
      endDate: '2018-12-31', //TODO: initial endDate - Today ?
      locale: {
        direction: 'ltr', //direction of text
        format: 'DD-MM-YYYY', //format of the dates displayed
        separator: ' - ', //separator between the two ranges
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: moment.weekdaysMin(), //array of days - see moment documentations for details
        monthNames: moment.monthsShort(), //array of month names - see moment documentations for details
        firstDay: 1 //ISO first day of week - see moment documentations for details
      },
      authorization: 'Bearer '+localStorage.getItem('z_token'),
      chart_loading: false,
      chart_data: { //TODO: initial chart data - necessary ?
        bus: new Vue(),
        label: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
      },
      form: {
        action : null //for Select Action
      },
      actions: [
        {text: 'Select Action', value: null},
        'book_01', 'book_02', 'book_03' //TODO: must dynamic action
      ]
    }
  },
  methods: {
    updateValues (values) {
      // console.log(values);
      if(typeof values.startDate != "undefined"){
        let start_date = values.startDate.toISOString().slice(0, 10);
        let end_date = values.endDate.toISOString().slice(0, 10);
        this.startDate = start_date;
        this.endDate = end_date;
      }

      // console.log(values.startDate.toISOString());
      let get_url = process.env.VUE_APP_API_URL + 'api/v1/report/clicks?';
      get_url += 'date_start=' + this.startDate;
      get_url += '&date_end=' + this.endDate;
      if(this.form.action != null){
        get_url += '&action=' + this.form.action;
      }

      let config = {
        headers: {
          Authorization: this.authorization,
        },
      };

      // this.$http.get(get_url, config)
      this.chart_loading = true;
      axios.get(get_url, config)
              .then((return_data) => {
                let response = return_data.data;
                if(response.hasOwnProperty('json') && response.json.length > 0){
                  this.generateChartData(response.json);
                }
                let showResponse = 'Select Action = ' + this.form.action;
                this.showSuccessMsg({title: 'GET Response', message: showResponse});
              })
              .catch((error) => {
                console.log('GET Error = ' + error);
                this.showErrorMsg({title: 'GET Error', message: error});
              })
              .then(() => {
                this.chart_loading = false;
              });
      ;
    },
    generateChartData(data) {
      let unordered = {};
      for(let i in data) {
        if(data.hasOwnProperty(i)){
          let date = data[i].date_s;
          unordered[date] = data[i].count;
        }
      }
      let ordered = {};
      Object.keys(unordered).sort().forEach(function(key) {
        ordered[key] = unordered[key];
      });
      // console.log(ordered);

      let labelArray = [];
      let dataArray = [];
      for(let key in ordered) {
        if(ordered.hasOwnProperty(key)) {
          labelArray.push(key);
          dataArray.push(ordered[key]);
        }
      }
      this.chart_data.label = labelArray;
      this.chart_data.data = dataArray;
      this.chart_data.bus.$emit('updateChart');
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Hello there',
      message: 'That\'s the success!'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Hey you',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Wow, man',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'Wow-wow',
      message: 'That\'s the error'
    }
  }
}
</script>
<style src='vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css'>
  /* global styles */
</style>
